import React from 'react';
import { Row, Col } from 'antd';
import classnames from 'classnames';

import './index.less';

interface IProps {
  title: string;
  icon: string;
  list?: ListItems[];
  coverage?: React.ReactNode;
  className?: string;
}

interface ListItems {
  label?: string;
  value?: string | number;
  type?: 'strong' | 'selfDesign';
  labelAfter?: any;
  children?: ListItems[];
  render?: any;
  style?: React.CSSProperties;
}

const ListItem = (props: IProps) => {
  const { title, icon, list, coverage, className } = props;

  const prefixCls = 'global-list-item';

  return (
    <div
      className={classnames(prefixCls, {
        [className as string]: !!className,
      })}
    >
      <Row gutter={[0, 8]}>
        <Col span={24} className={`${prefixCls}-title`}>
          <div className={`${prefixCls}-title-icon-wrap`}>
            <img
              src={icon}
              className={`${prefixCls}-title-icon-wrap-img`}
            ></img>
          </div>
          <span>{title}</span>
        </Col>

        {coverage && (
          <Col span={24} className={`${prefixCls}-coverage`}>
            <div className={`${prefixCls}-coverage-text`}>{coverage}</div>
          </Col>
        )}

        <Col span={24} className={`${prefixCls}-content`}>
          {list?.map(
            (
              { children, label, value, labelAfter, type, render, style },
              index,
            ) => {
              if (type === 'selfDesign') {
                return render();
              }
              return (
                <div
                  key={index}
                  className={classnames(`${prefixCls}-content-list`, {
                    [`${prefixCls}-content-strong-list`]: type === 'strong',
                  })}
                  style={style ?? {}}
                >
                  <Row
                    className={classnames(`${prefixCls}-content-list-row`)}
                    justify="space-between"
                  >
                    <div className="leftSection">
                      <span>{label}</span>
                      <span className={`${prefixCls}-content-list-label-after`}>
                        {labelAfter}
                      </span>
                    </div>
                    <div className="rightSection">{value}</div>
                  </Row>

                  {children &&
                    children.map(({ label, value }, childIndex) => {
                      return (
                        <div className={`${prefixCls}-content-list-sub-list`}>
                          <Row
                            className={`${prefixCls}-content-list-sub-list-row`}
                            key={childIndex}
                            justify="space-between"
                          >
                            <div className="leftSection">{label}</div>
                            <div className="rightSection">{value}</div>
                          </Row>
                        </div>
                      );
                    })}
                </div>
              );
            },
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ListItem;
